import InputField from "components/fields/InputField";
import Checkbox from "components/checkbox";
import EyeIcon from "components/icons/EyeIcon";
import EyeOffIcon from "components/icons/EyeOffIcon";
import { Spinner } from "@material-tailwind/react";

import Swal from "sweetalert2";

import { signInApi, signInOperatorApi } from "api/superAdmin";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { setCookie } from "./../../utils/cookies";
import { userAccess } from "api/superAdmin";

export default function SignIn() {
  const navigate = useNavigate();

  const [userForm, setUserForm] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserForm({ ...userForm, [name]: value });
  };

  const handleSignInM = async () => {
    setIsLoading(true);
    try {
      const userIsAdmin = await userAccess(userForm.email)
      console.log("userIsAdmin.data", userIsAdmin.data)

      if(userIsAdmin.data) {
        const response = await signInApi(userForm.email, userForm.password);

        await setCookie("T6hVzR7c0g3maM3F", response.token.content)
        await setCookie("02hfCmUqpk66w4uG", response.token.iv)
        await setCookie("3F2Mb2pJ1YRro5Z4", response.userInfo._id)
  
        await setCookie("lv9u765qzk1gr4fn1e", "TRUE")
        window.location.reload()

        return
      }
      else if(!userIsAdmin.data) {
        const response = await signInOperatorApi(userForm.email, userForm.password);

        await setCookie("T6hVzR7c0g3maM3F", response.token.content)
        await setCookie("02hfCmUqpk66w4uG", response.token.iv)
        await setCookie("3F2Mb2pJ1YRro5Z4", response.userInfo._id)

        await setCookie("lv9u765qzk1gr4fn1e", "FALSE")
        window.location.reload()

        return
      }
    } catch (error) {
      console.log("error =>", error)
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.error,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          AUTHENTIFICATION DV
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          ACCEDEZ A VOTRE ARDUNIFER
        </p>
        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="mail@simmmple.com"
          id="email"
          type="text"
          value={userForm.email}
          name="email"
          onChange={handleInputChange}
        />

        {/* Password */}
        <div className="mb-3">
          <label
            htmlFor="password"
            className="ml-1.5 text-sm font-medium text-navy-700 dark:text-white"
          >
            Mot de pass*
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              placeholder=""
              className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 pr-12 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white"
              name="password"
              value={userForm.password}
              onChange={handleInputChange}
            />
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              {showPassword ? (
                <EyeOffIcon onClick={() => setShowPassword(false)} />
              ) : (
                <EyeIcon onClick={() => setShowPassword(true)} />
              )}
            </div>
          </div>
        </div>
        {/* Checkbox */}
        <div className="mb-4 flex items-center justify-between px-2">
          {/* <div className="flex items-center">
            <Checkbox />
            <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
              Keep me logged In
            </p>
          </div> */}
          {/* <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href=" "
          >
            Forgot Password?
          </a> */}
        </div>
        <button
          className={`linear mt-2 w-full rounded-xl py-[12px] text-base font-medium text-white transition duration-200 ${
            isLoading 
              ? "bg-gray-400 cursor-not-allowed dark:bg-gray-600" 
              : "bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"
          }`}
          onClick={handleSignInM}
          disabled={isLoading}
        >
          {isLoading ? (
            <div className="flex items-center justify-center">
              <Spinner className="h-5 w-5 mr-2" />
              Connexion...
            </div>
          ) : (
            "Sign In"
          )}
        </button>
        {/* <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
            Not registered yet?
          </span>
          <a
            href=" "
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Create an account
          </a>
        </div> */}
      </div>
    </div>
  );
}
